<template>
  <section class="map-container">

    <GMapMap
        :center="center"
        :style="{width: '100%', height: '100%' }"
        :zoom="zoom"
        :options="{
        styles: [{'featureType':'all','elementType':'labels','stylers':[{'visibility':'off'}]},{'featureType':'administrative','elementType':'all','stylers':[{'visibility':'off'},{'color':'#5b6571'},{'lightness':'35'}]},{'featureType':'administrative.neighborhood','elementType':'all','stylers':[{'visibility':'off'}]},{'featureType':'landscape','elementType':'all','stylers':[{'visibility':'on'},{'color':'##f0f0f0'}]},{'featureType':'landscape.man_made','elementType':'geometry','stylers':[{'weight':0.9},{'visibility':'off'}]},{'featureType':'poi.attraction','elementType':'all','stylers':[{'visibility':'off'}]},{'featureType':'poi.attraction','elementType':'labels.icon','stylers':[{'visibility':'off'}]},{'featureType':'poi.park','elementType':'geometry.fill','stylers':[{'visibility':'on'},{'color':'#B5D098'}]},{'featureType':'road','elementType':'all','stylers':[{'visibility':'on'},{'color':'#ffffff'}]},{'featureType':'road','elementType':'labels','stylers':[{'visibility':'off'}]},{'featureType':'road.highway','elementType':'all','stylers':[{'visibility':'off'},{'color':'#fee379'}]},{'featureType':'road.highway','elementType':'geometry','stylers':[{'visibility':'off'}]},{'featureType':'road.highway','elementType':'labels','stylers':[{'visibility':'off'}]},{'featureType':'road.highway','elementType':'labels.icon','stylers':[{'visibility':'off'}]},{'featureType':'road.highway.controlled_access','elementType':'labels.icon','stylers':[{'visibility':'off'}]},{'featureType':'road.arterial','elementType':'all','stylers':[{'visibility':'simplified'},{'color':'#ffffff'},{'saturation':'0'}]},{'featureType':'road.arterial','elementType':'labels','stylers':[{'visibility':'off'}]},{'featureType':'road.arterial','elementType':'labels.text','stylers':[{'visibility':'on'},{'color':'#ff0000'}]},{'featureType':'road.arterial','elementType':'labels.text.fill','stylers':[{'color':'#9e9e9e'}]},{'featureType':'road.arterial','elementType':'labels.text.stroke','stylers':[{'color':'#ffffff'},{'weight':'0.92'}]},{'featureType':'road.arterial','elementType':'labels.icon','stylers':[{'visibility':'off'}]},{'featureType':'transit.station.airport','elementType':'all','stylers':[{'visibility':'on'}]},{'featureType':'transit.station.airport','elementType':'labels.icon','stylers':[{'visibility':'on'}]},{'featureType':'transit.station.rail','elementType':'all','stylers':[{'visibility':'on'}]},{'featureType':'transit.station.rail','elementType':'labels','stylers':[{'visibility':'simplified'},{'saturation':'0'}]},{'featureType':'transit.station.rail','elementType':'labels.text','stylers':[{'color':'#646464'}]},{'featureType':'water','elementType':'all','stylers':[{'visibility':'on'},{'color':'#7fc8ed'}]}],
        disableDefaultUI:true,
        maxZoom: 18,
        minZoom: 11
        }"
        @zoom_changed="updateZoom"
        ref="map"
        @click="resetMarker()"
    >

      <GMapMarker
          :position="{lat: cityCenterLat, lng: cityCenterLng}"
          :clickable="true"
          :draggable="false"
          :icon="{ url: getIconCityCenter()}"
      />

      <GMapMarker
          :position="{lat: congressLat, lng: congressLng}"
          :clickable="true"
          :draggable="false"
          :icon="{ url: getIconCongress()}"
      />
      <GMapCluster
          :styles="getClusterStyles()"
          :minimumClusterSize="minimumClusterSize"
          :gridSize="clusterGridSize"
          :maxZoom="16"
          :averageCenter="true"
          :zoomOnClick="true">
        <GMapMarker
            v-for="m in markers"
            :key="`marker-hotel-${m.id}`"
            :position="m.position"
            :clickable="true"
            :draggable="false"
            @click="handleMarkerClick(m.position, m.hotel)"
            :label="m.label"
            :icon="m.icon"
            :map="m.map"
        />
      </GMapCluster>

      <gmap-custom-marker
          v-if="clickedHotel"
          :marker="currentMarker"
          :offsetY="-50"
      >
        <hotel-card-detail :inMap="true" :hotel="hotelMarkerDetail" :mobileMapViewActivated="mobileMapViewActivated"/>
      </gmap-custom-marker>
    </GmapMap>

    <hotel-custom-zoom v-on:zoomIn="zoomIn" v-on:zoomOut="zoomOut"/>

  </section>

</template>

<script>
import {mapGetters} from 'vuex'
import {calculateHotelPriceHelper} from '../../helpers/calculateHotelPrice'
import Constants from '@/constants'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import HotelCardSmall from './HotelCardSmall.vue'
import HotelCustomZoom from './maps/HotelCustomZoom.vue'
import HotelMapViewToggle from './maps/HotelMapViewToggle.vue'

export default {
  name: 'HotelMap',
  components: {
    'gmap-custom-marker': GmapCustomMarker,
    'hotel-card-detail': HotelCardSmall,
    'hotel-custom-zoom': HotelCustomZoom,
    'hotel-map-view-toggle': HotelMapViewToggle,
  },
  props: {
    hotels: Array,
    initialZoom: Number,
    center: Object,
    singleHotelMode: Boolean,
    hoveredHotel: Object,
    mobileMapViewActivated: Boolean
  },
  data: function () {
    return {
      processedPoiList: [],
      currentMarker: {
        lat: null,
        lng: null
      },
      markers: [],
      hotelMarkerDetail: null,
      clickedHotel: false,
      clickMarker: false,
      clusterStyles: [
        {
          textColor: '#333333',
          height: 89,
          width: 64,
          anchorText: [-29, 0],
          textSize: 17,
          url: require('@/assets/maps/ic_map_cluster_hotels_label.svg')
        }
      ],
      clusterGridSize: 40,
      minimumClusterSize: 3,
      zoom: null
    }
  },
  watch: {
    hoveredHotel: function (newValue) {
      this.resetMarker()
      if (newValue !== null) {
        this.handleMarkerClick({lat: newValue.location.coordinates[1], lng: newValue.location.coordinates[0]}, newValue)
      } else {
        this.resetMarker()
      }
    },
    map_hotels(newValue) {
      this.createMarkers()
      return newValue
    }
  },
  computed: {
    google_lib() {
      return google
    },
    ...mapGetters([
      'filteredHotels',
      'congressLat',
      'congressLng',
      'cityCenterLat',
      'cityCenterLng',
      'dataIsReady',
      'dataHotelsIsReady',
      'site'
    ]),
    map_hotels() {
      return this.hotels || this.filteredHotels
    }
  },
  mounted: function () {
    this.zoom = this.initialZoom
    this.createMarkers()
  },
  methods: {
    getClusterStyles() {
      if (this.site.language == Constants.SPANISH_LANGUAGE_CODE) {
        this.clusterStyles[0].url = require('@/assets/maps/ic_map_cluster_hotels_label_es.svg')
        return this.clusterStyles
      }
      return this.clusterStyles
    },
    getIconCityCenter() {
      if (this.site.language == Constants.SPANISH_LANGUAGE_CODE) {
        return require('@/assets/maps/ic_map_city_center_es.svg')
      }
      return require('@/assets/maps/ic_map_city_center.svg')
    },
    getIconCongress() {
      if (this.site.language == Constants.SPANISH_LANGUAGE_CODE) {
        return require('@/assets/maps/ic_map_congress_es.svg')
      }
      return require('@/assets/maps/ic_map_congress.svg')
    },
    createMarkers() {
      this.$refs.map.$mapPromise.then((map) => {
        this.markers = this.map_hotels.map(hotel => {
          return {
            position: {lat: hotel.location.coordinates[1], lng: hotel.location.coordinates[0]},
            map: map,
            icon: this.getHotelMarkerIcon(hotel.stars),

            label: {'text': this.formatPrice(hotel.average_day_price), 'color': '#333333', 'fontWeight': 'bold'},
            clickable: true,
            id: hotel.id,
            hotel: hotel
          }
        })
        if (this.singleHotelMode)
          this.panMapToHotelAndCongress()
        else {
          if (!this.filteredHotels.length)
            this.zoom = 11
          else
            this.panMapToHotelsFound()
        }
        this.$nextTick(() => {
          this.updateMapPosition()
        })
      })
    },
    updateMapPosition() {
      if(this.$store.getters.prevUrl.startsWith('/hotel')) {
        this.$refs.map.$mapPromise.then(map => map.setCenter(this.$store.getters.map_position.position))
        this.zoom = this.$store.getters.map_position.zoom
      }
    },
    handleMarkerClick(latLng, hotel) {
      this.$refs.map.$mapPromise.then(map =>
      this.$store.commit("SET_MAP_POSITION", {'position': map.getCenter().toJSON(), 'zoom': this.zoom}))
      if (this.currentMarker !== latLng) {
        this.resetMarker()
      }
      if (!this.currentMarker) {
        this.clickMarker = true
        this.setMarker(latLng, hotel)
      } else {
        this.resetMarker()
      }
    },
    setMarker(latLng, hotel) {
      this.currentMarker = latLng
      this.hotelMarkerDetail = hotel
      this.clickedHotel = true
    },
    resetMarker() {
      if (this.clickMarker) {
        this.clickMarker = false
      } else {
        this.currentMarker = null
        this.hotelMarkerDetail = null
        this.clickedHotel = false
      }

    },
    zoomIn() {
      if (this.zoom <= 21) {
        this.zoom++
      }
    },
    zoomOut() {
      if (this.zoom >= 10) {
        this.zoom--
      }
    },
    updateZoom(zoom) {
      this.zoom = zoom
    },
    getHotelMarkerIcon(hotelStars) {
      const markerObject = {
        labelOrigin: {x: 27, y: 22}
      }

      if ([1, 2, 3, 4, 5].includes(hotelStars)) {
        markerObject.url = require('../../assets/maps/ic_map_hotel_label_' + hotelStars + '_stars.svg')
      }
      else {
        markerObject.url = require('../../assets/maps/ic_map_hotel_label.svg')
      }
      return markerObject
    },
    calculateHotelPrice(hotel) {
      return calculateHotelPriceHelper(hotel)
    },
    panMapToHotelsFound() {
      this.panMap(this.markers)
    },
    panMapToHotelAndCongress() {
      const markers = [
        ...this.markers,
        {position: {lat: this.congressLat, lng: this.congressLng}}
      ]
      this.panMap(markers)
    },
    panMap(markers) {
      this.$refs.map.$mapPromise.then(map => {
        const bounds = new this.google_lib.maps.LatLngBounds()
        markers.forEach(marker => {
          bounds.extend(marker.position)
          map.fitBounds(bounds)
          this.$refs.map.fitBounds(bounds)
        })
      })
    },
    formatPrice (price) {
      if (this.dataHotelsIsReady)
        return Math.ceil(price) + ' €'
      return ' '
    },
    routeToHotelDetail () {
      this.$router.push({
        name: 'hotel-detail-page',
        params: {
          id: this.hotelMarkerDetail.id
        }
      })
    }
  }
}
</script>

<style lang="scss">

.map-container {
  height: 100%;
  position: relative;
  margin: 0;
  padding-top: 4px;
}

div.cluster {
  z-index: -50;
}

@media (max-width: 768px) {

  .zoom {
    display: none;
  }

}

</style>
